if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.submitButton = this.querySelector('[type="submit"]');
      this.cart = document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.sectionId = this.form.id?.replace('Product-Form-', '');
      this.stickyButton = this.sectionId ? document.getElementById(`StickyAddToCart-${this.sectionId}`) : null;
      this.variantInput = this.form.querySelector('[name="id"]');

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.variantInput?.addEventListener('change', () => {
        window.SkinNoteProductInventory?.syncForm?.(this.form, { showError: true });
      });
      window.SkinNoteProductInventory?.syncForm?.(this.form);
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-icon-bubble', // ID = id of the element that needs to be updated
          section: 'cart-icon-bubble', // SECTION = name of the Shopify file that needs to be rendered
          selector: '.shopify-section', // Selector
        }
      ]
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Passing no argument will hide the error message if one was on screen because errorText defaults to false
      this.handleErrorMessage();

      const addValidation = window.SkinNoteProductInventory?.validateAdd?.(this.form);
      if (addValidation && !addValidation.ok) {
        this.handleErrorMessage(addValidation.message);
        return;
      }

      const formData = new FormData(this.form);

      // Disabling the button temporarily so that the request can be processed
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.stickyButton?.setAttribute('aria-disabled', 'true');
      this.stickyButton?.setAttribute('aria-busy', 'true');
      this.stickyButton?.classList.add('loading');

      const config = {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        }
      };

      const quickAddModal = this.closest('quick-add-modal');

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        if (quickAddModal) {
          quickAddModal.hide(true);
          window.setTimeout(() => {
            this.cart.showPending?.(document.activeElement);
          }, 180);
        } else {
          this.cart.showPending?.(document.activeElement);
        }
      } else {
        formData.append('sections', this.getSectionsToRender().map(section => section.id));
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.dispatchEvent(
              new CustomEvent(PUB_SUB_EVENTS.cartError, {
                bubbles: true,
                detail: { message: response.message, error: response.description },
              })
            );
            this.handleErrorMessage(response.description);
            this.error = true;
            this.cart?.clearUpdating?.();
            return;
          }

          this.error = false;

          if (quickAddModal && quickAddModal.isOpen) {
            quickAddModal.hide(true);
          }

          if (this.cart) {
            this.cart.renderContents(response, { scrollToTop: true });
          } else {
            this.getSectionsToRender().forEach((section) => {
              document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
            });
            // Redirect to cart page
            window.location.href = window.routes.cart_url;
          }
        })
        .catch((error) => {
          console.error(error);
          this.cart?.clearUpdating?.();
        })
        .finally((response) => {
          this.submitButton.classList.remove('loading');
          this.stickyButton?.classList.remove('loading');
          this.stickyButton?.removeAttribute('aria-busy');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.stickyButton?.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorText = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorText);

      this.errorMessage.textContent = errorText ? errorText : '';
    }
  });
}

window.SkinNoteAddToCartFallback = window.SkinNoteAddToCartFallback || (() => {
  function getSubmitButton(form, event) {
    if (event.submitter?.matches?.('button, input[type="submit"]')) return event.submitter;
    const active = document.activeElement;
    if (active?.closest?.('form') === form && active.matches?.('button, input[type="submit"]')) return active;
    return form.querySelector('button[type="submit"], button[name="add"], input[type="submit"]');
  }

  function isBlocked(button) {
    return Boolean(
      button?.disabled ||
      button?.getAttribute?.('aria-disabled') === 'true' ||
      button?.closest?.('[aria-disabled="true"]')
    );
  }

  function getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  function fallbackCloseCartDrawer(cartDrawer) {
    cartDrawer?.classList.remove('open', 'is-closing');
    if (cartDrawer) cartDrawer.style.visibility = 'hidden';
    document.body.classList.remove('cart-drawer-open', 'overflow-hidden');
    window.SkinNoteDrawers?.unlock?.('cart');
  }

  function bindFallbackCartControls(cartDrawer) {
    if (!cartDrawer || cartDrawer.dataset.fallbackControlsReady === 'true') return;
    cartDrawer.dataset.fallbackControlsReady = 'true';
    cartDrawer.addEventListener('click', (event) => {
      if (!event.target.closest('#CartDrawer-Close, #CartDrawer-Overlay')) return;
      event.preventDefault();
      if (typeof cartDrawer.close === 'function') {
        cartDrawer.close();
      } else {
        fallbackCloseCartDrawer(cartDrawer);
      }
    });
  }

  function openFallbackCartDrawer(cartDrawer) {
    if (!cartDrawer) return;
    bindFallbackCartControls(cartDrawer);
    cartDrawer.classList.remove('is-empty', 'is-closing');
    cartDrawer.classList.add('motion-ready', 'open');
    cartDrawer.style.visibility = 'visible';
    document.body.classList.add('cart-drawer-open', 'overflow-hidden');
    window.SkinNoteDrawers?.lock?.('cart');
  }

  function renderFallbackCart(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(parsedState, { scrollToTop: true });
      return;
    }

    const drawerHTML = parsedState.sections?.['cart-drawer'];
    const bubbleHTML = parsedState.sections?.['cart-icon-bubble'];

    if (drawerHTML) {
      const nextDrawer = new DOMParser().parseFromString(drawerHTML, 'text/html').querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');
      if (nextDrawer && currentDrawer) currentDrawer.innerHTML = nextDrawer.innerHTML;
    }

    if (bubbleHTML) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) bubble.innerHTML = getSectionInnerHTML(bubbleHTML);
    }

    openFallbackCartDrawer(document.querySelector('cart-drawer'));
  }

  async function handleSubmit(event) {
    if (event.defaultPrevented) return;

    const form = event.target;
    if (!form?.matches?.('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    const quickAddModal = form.closest('quick-add-modal');

    const submitButton = getSubmitButton(form, event);
    if (isBlocked(submitButton)) {
      event.preventDefault();
      return;
    }

    event.preventDefault();

    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.disabled = false;

    const addValidation = window.SkinNoteProductInventory?.validateAdd?.(form);
    if (addValidation && !addValidation.ok) {
      const productForm = form.closest('product-form');
      if (typeof productForm?.handleErrorMessage === 'function') {
        productForm.handleErrorMessage(addValidation.message);
      } else {
        window.SkinNoteCartLimit?.showInlineError?.(submitButton || form, addValidation.message);
      }
      return;
    }

    const formData = new FormData(form);

    submitButton?.setAttribute?.('aria-disabled', 'true');
    submitButton?.classList?.add('loading');

    if (quickAddModal) {
      quickAddModal.hide?.(true);
      window.setTimeout(() => {
        cartDrawer.showPending?.(submitButton || document.activeElement);
      }, 180);
    } else {
      cartDrawer.showPending?.(submitButton || document.activeElement);
    }

    const sections = typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map((section) => section.id)
      : ['cart-drawer', 'cart-icon-bubble'];

    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const parsedState = await response.json();

      if (parsedState.status) {
        cartDrawer.clearUpdating?.();
        return;
      }

      renderFallbackCart(parsedState);
    } catch (error) {
      console.error(error);
      cartDrawer.clearUpdating?.();
    } finally {
      submitButton?.classList?.remove('loading');
      submitButton?.removeAttribute?.('aria-disabled');
      if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    }
  }

  document.addEventListener('submit', handleSubmit);

  return { handleSubmit };
})();
